var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 34,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E30513",
    d: "M.266 22.867c2.421-.416 4.687-1.38 6.796-2.89 2.136-1.537 3.737-3.425 4.805-5.665H.97V10.72h12.07c.339-1.693.508-3.581.508-5.664H.969v-3.75h16.289c.338 0 .625.104.86.312.234.182.35.495.35.938 0 2.812-.208 5.351-.624 7.617h6.328V.289h4.531v28.008h-4.531V13.844h-7.305c-2.5 7.135-8.034 11.523-16.601 13.164v-4.14Zm38.28-6.055c-.858 0-1.575-.26-2.148-.78-.573-.548-.859-1.25-.859-2.11V.914h4.531v12.227h8.946v3.671h-10.47Zm.704 4.22h22.07c.625 0 1.146.195 1.563.585.416.39.625.899.625 1.524v10.703h-4.531V24.78H39.25v-3.75Zm7.305-15.274h5.547V.445h4.296v17.93h-4.296V9.508h-5.547v-3.75ZM59.133.289h4.375v18.242h-4.375V.29Zm16.64 4.219v7.07h21.211v3.672H73.04c-.495 0-.924-.156-1.289-.469-.338-.312-.508-.729-.508-1.25V.836h25.469v3.672H75.773ZM68.898 18.96h30.079v3.75h-6.915v7.656h-4.53v-7.656h-7.188v7.656h-4.531v-7.656h-6.915v-3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5732660f6c0c70917a83edb0524e800d.svg";
export { ForwardRef as ReactComponent };